import { type AppState } from 'src/redux/app/app.store'

export const selectWarehouses = (state: AppState) => state.warehouse.warehouses
export const selectPinnedWarehouses = (state: AppState) => state.warehouse.pinnedWarehouses
